<template>
  <div class="menu-box">
    <div class="logo-box">
      <p>แฟลชเงิน</p>
    </div>
    <div class="list">
      <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)"> บ้าน </div>
      <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)"> เกี่ยวกับ </div>
      <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)"> ติดต่อเรา </div>
      <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)"> ลบข้อมูล</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "about" });
          break;
        case 3:
          this.$router.push({ path: "contact" });
          break;
        case 4:
          this.$router.push({ path: "Del" });
          break;
        // case 5:
        //   this.$router.push({ path: "contact" });
        //   break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.menu-box {
  position: fixed;
  width: 970px;
  height: 105px;
  background: #0E0729;
  border-radius: 26px 26px 26px 26px;
  top: 59px;
  left: 0px;
  right: 0px;
  margin: auto;
  padding: 0px 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 999;

  .logo-box {
    font-weight: 600;
    font-size: 32px;
    color: #FFFFFF;
  }

  .list {
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    display: flex;
    align-items: center;

    div {
      padding: 0px 15px;
      cursor: pointer;
    }

    .select {
      font-weight: bold;
      font-size: 16px;
      color: #CB7BFC;
    }
  }
}
</style>
